import { render, staticRenderFns } from "./EditableElement.vue?vue&type=template&id=3816a4c1&scoped=true&"
import script from "./EditableElement.vue?vue&type=script&lang=js&"
export * from "./EditableElement.vue?vue&type=script&lang=js&"
import style0 from "./EditableElement.vue?vue&type=style&index=0&id=3816a4c1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3816a4c1",
  null
  
)

export default component.exports